module.exports = __webpack_public_path__ + "img/to_openspace.6fa60f6e.png";